import * as Yup from "yup";

export const InternalUsersValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email is not valid")
    .required("Email is required!").nullable(),

  firstName: Yup.string().required("First Name is required!").nullable(),
  phoneNumber: Yup.string()
    .min(10, "Phone Number should not be more or less then 10 digits")
    .max(10, "Phone Number should not be more or less then 10 digits")
    .required("Phone Number is required!").nullable(),
  roleId: Yup.string().required("Role is required!").nullable(),

  password: Yup.string()
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "The minimum password length is 8 characters and must contain atleast 1 lowercase letter, 1 capital letter, 1 number, and 1 special character"
    )
    .required("Password is required!").nullable(),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("password")],
    "Both passwords need to be the same"
  ).nullable(),
});
